export default __webpack_public_path__ + "static/img1-09e2f4207e91c379e02433dd045a2554.png";